<template>
    <div></div>
</template>

<script>
    import { isAndroid, isIOS } from 'mobile-device-detect';
    export default {
        props: {

        },

        computed: {

        },

        methods: {
            redirectToAppstore(){
                let storeLink;
                if(isIOS) {
                    storeLink = "https://itunes.apple.com/hk/app/hyperair-money-exchange-sim/id1397364347";
                    window.location = storeLink;
                }else if(isAndroid){
                    storeLink = "http://market.android.com/details?id=com.hyperair.app";
                    window.location = storeLink;
                }
            }
        },

        mounted() {
            let urlParams = new URLSearchParams(window.location.search);
            let redirectToAppstore = (urlParams.get('redirect_to_appstore') === 'true');
            if(redirectToAppstore){
                this.redirectToAppstore();
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
